import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import jpkp from "../Assets/jpkp.png";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io"; // Added Dropup
import SummaryApi from "../common";

const Navbar = () => {
  const [eventsDropdown, setEventsDropdown] = useState(false);
  const [coursesDropdown, setCoursesDropdown] = useState(false);
  const [facilitiesDropdown, setFacilitiesDropdown] = useState(false);
  const [mobileFacilitiesOpen, setMobileFacilitiesOpen] = useState(false); // New state for Mobile Dropdown
  const [uniqueCategoryNames, setUniqueCategoryNames] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [events, setEvents] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const activeLinkStyle = { color: "#FDDA0D" };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Close the sub-dropdown when the main menu is closed
    if (menuOpen) setMobileFacilitiesOpen(false);
  };

  const facilities = [
    {
      name: "Online Grievance Redressal Mechanism",
      path: "/facilities/online-grievance",
    },
    { name: "Anti-Ragging Committee", path: "/facilities/anti-ragging" },
    {
      name: "Internal Complaint Committee",
      path: "/facilities/internal-complaint",
    },
    { name: "Community for SC/ST", path: "/facilities/community-sc-st" },
    { name: "Food Safety", path: "/facilities/food-safety" },
    {
      name: "Board of Governors & Mandatory disclosure",
      path: "/facilities/board-of-governors",
    },
    {
      name: "Institution Industry Cell",
      path: "/facilities/institution-industry-cell",
    },
    { name: "AICTE Feedback Facility", path: "/facilities/aicte-approval" },
  ];

  useEffect(() => {
    fetch(SummaryApi.getevents.url, {
      method: "get",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.data) {
          setEvents(data.data);
          const lastFiveEvents = data.data.slice(-5);
          const categoryNames = lastFiveEvents.map(
            (event) => event.category_name,
          );
          const uniqueCategories = [...new Set(categoryNames)];
          setUniqueCategoryNames(uniqueCategories);
        }
      })
      .catch((error) => console.error("Error fetching events:", error));
  }, []);

  const isActive = (path) => location.pathname === path;
  const navbarClass = location.pathname === "/" ? "" : "bg-[#2C9CB5]";

  return (
    <nav
      className={`m-0 p-0 flex justify-between items-center py-1 px-2 sticky top-0 z-[99] ${navbarClass}`}
    >
      <div className="nav-items flex justify-between items-center flex-grow gap-5">
        {/* Hamburger Menu Icon */}
        <div
          className="hamburger flex lg:hidden text-white cursor-pointer"
          onClick={toggleMenu}
        >
          <FaBars size={30} />
        </div>

        {location.pathname !== "/" && (
          <div className="logoimagejpkp flex items-center">
            <a href="/">
              <img src={jpkp} alt="LOGO" className="w-40" />
            </a>
          </div>
        )}

        {/* DESKTOP MENU */}
        <div className="mt-3">
          <ul className="nav-links hidden lg:flex list-none gap-5 text-[25px] items-center">
            <li className="mx-[15px]">
              <a
                href="/"
                className="text-white font-[Poly] text-[20px] no-underline"
                style={isActive("/") ? activeLinkStyle : {}}
              >
                Home
              </a>
            </li>
            <li className="mx-[15px]">
              <a
                href="/about"
                className="text-white font-[Poly] text-[20px] no-underline"
                style={isActive("/about") ? activeLinkStyle : {}}
              >
                About
              </a>
            </li>
            <li className="mx-[15px]">
              <a
                href="/Admissions"
                className="text-white font-[Poly] text-[20px] no-underline"
                style={isActive("/Admissions") ? activeLinkStyle : {}}
              >
                Admissions
              </a>
            </li>

            {/* Courses Dropdown (Desktop) */}
            <li className="mx-[15px]">
              <div
                className="relative inline-block text-white"
                onMouseEnter={() => setCoursesDropdown(true)}
                onMouseLeave={() => setCoursesDropdown(false)}
              >
                <a
                  href="/courses"
                  className="text-lg flex items-center text-white font-[Poly] text-[20px]"
                  style={isActive("/courses") ? activeLinkStyle : {}}
                >
                  Courses <IoMdArrowDropdown />
                </a>
                {coursesDropdown && (
                  <div className="absolute left-0 mt-1 bg-[#2C9CB5] w-60 py-1 rounded-lg shadow-lg grid grid-cols-2 gap-2 z-[99999] border-t-2 border-[#FDDA0D]">
                    {["AIML", "CCB", "CME", "CIV", "ECE", "EEE", "MEC"].map(
                      (course, idx) => (
                        <a
                          key={idx}
                          href={`/course-details/${idx + 1}`}
                          className="block px-4 py-2 hover:bg-[#1f7d8b] text-[16px] font-[Poly] text-white"
                        >
                          {course}
                        </a>
                      ),
                    )}
                  </div>
                )}
              </div>
            </li>

            <li className="mx-[15px]">
              <a
                href="/Examcell"
                className="text-white font-[Poly] text-[20px] no-underline"
                style={isActive("/Examcell") ? activeLinkStyle : {}}
              >
                Exam Cell
              </a>
            </li>

            {/* Other Facilities Dropdown (Desktop) */}
            <li className="mx-[15px]">
              <div
                className="relative inline-block text-white"
                onMouseEnter={() => setFacilitiesDropdown(true)}
                onMouseLeave={() => setFacilitiesDropdown(false)}
              >
                <button className="flex items-center text-white font-[Poly] text-[20px] bg-transparent border-none cursor-pointer">
                  Other Facilities <IoMdArrowDropdown />
                </button>
                {facilitiesDropdown && (
                  <div className="absolute left-0 bg-[#2C9CB5] w-60 py-2 rounded-lg shadow-xl z-[99999] border-t-2 border-[#FDDA0D] flex flex-col text-left">
                    {facilities.map((facility, index) => (
                      <a
                        key={index}
                        href={facility.path}
                        className="px-5 py-3 text-[17px] font-[Poly] text-white hover:bg-[#1f7d8b] border-b border-white/10 last:border-none transition-colors leading-tight"
                      >
                        {facility.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </li>

            {/* Events Dropdown (Desktop) */}
            <li className="mx-[15px]">
              <div
                className="relative inline-block text-white"
                onMouseEnter={() => setEventsDropdown(true)}
                onMouseLeave={() => setEventsDropdown(false)}
              >
                <a
                  href="/EventS"
                  className="text-lg flex items-center text-white font-[Poly] text-[20px]"
                  style={isActive("/EventS") ? activeLinkStyle : {}}
                >
                  Events <IoMdArrowDropdown />
                </a>
                {eventsDropdown && (
                  <div className="absolute left-0 mt-1 bg-[#2C9CB5] w-56 py-1 rounded-lg shadow-lg z-[99999] border-t-2 border-[#FDDA0D]">
                    {uniqueCategoryNames.map((cat, i) => (
                      <div
                        key={i}
                        onClick={() => navigate("/EventS")}
                        className="p-3 cursor-pointer hover:bg-[#1a7b8b] text-[17px] text-white font-[Poly]"
                      >
                        {cat}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </li>

            <li className="mx-[15px]">
              <a
                href="/form"
                className="text-white font-[Poly] text-[20px] no-underline"
                style={isActive("/form") ? activeLinkStyle : {}}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* MOBILE MENU */}
        <ul
          className={`nav-links-mobile ${menuOpen ? "open" : ""} lg:hidden flex flex-col absolute w-full top-[50px] left-0 bg-[#2C9CB5] z-[999] shadow-xl transition-all max-h-[85vh] overflow-y-auto`}
        >
          <li>
            <a
              href="/"
              className="text-white font-[Poly] text-[20px] block py-3 border-b border-white/10"
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="/about"
              className="text-white font-[Poly] text-[20px] block py-3 border-b border-white/10"
            >
              About
            </a>
          </li>
          <li>
            <a
              href="/Admissions"
              className="text-white font-[Poly] text-[20px] block py-3 border-b border-white/10"
            >
              Admissions
            </a>
          </li>
          <li>
            <a
              href="/courses"
              className="text-white font-[Poly] text-[20px] block py-3 border-b border-white/10"
            >
              Courses
            </a>
          </li>
          <li>
            <a
              href="/Examcell"
              className="text-white font-[Poly] text-[20px] block py-3 border-b border-white/10"
            >
              Exam Cell
            </a>
          </li>

          {/* --- MOBILE DROPDOWN FOR FACILITIES --- */}
          <li className="border-b border-white/10">
            <button
              onClick={() => setMobileFacilitiesOpen(!mobileFacilitiesOpen)}
              className="w-full text-left text-white font-[Poly] text-[20px] py-3 flex justify-between items-center pr-5"
            >
              Other Facilities
              {mobileFacilitiesOpen ? (
                <IoMdArrowDropup size={24} />
              ) : (
                <IoMdArrowDropdown size={24} />
              )}
            </button>

            {/* Animated Dropdown Content */}
            <div
              className={`${mobileFacilitiesOpen ? "block" : "hidden"} bg-[#1f7d8b]/40 pb-2`}
            >
              {facilities.map((f, i) => (
                <a
                  key={i}
                  href={f.path}
                  className="text-white font-[Poly] text-[17px] block py-3 px-8 border-b border-white/5 last:border-none hover:bg-[#1f7d8b]"
                >
                  {f.name}
                </a>
              ))}
            </div>
          </li>

          <li>
            <a
              href="/EventS"
              className="text-white font-[Poly] text-[20px] block py-3 border-b border-white/10"
            >
              Events
            </a>
          </li>
          <li>
            <a
              href="/form"
              className="text-white font-[Poly] text-[20px] block py-3"
            >
              Contact
            </a>
          </li>
        </ul>

        {/* Call Button */}
        <a
          href="tel:8096951451"
          className="call-info flex flex-row items-center shadow-lg rounded-[15px] hidden md:flex"
        >
          <div className="bg-white rounded-[15px] p-3 flex items-center">
            <div className="Icon p-2 bg-[#FF7F50] rounded-full">
              <FiPhoneCall size={20} className="text-white" />
            </div>
            <div className="Number ml-2">
              <div className="text-[10px] font-bold text-gray-500 uppercase">
                Call Any Time
              </div>
              <div className="text-sm font-bold text-black">6304732269</div>
            </div>
          </div>
        </a>
      </div>

      <style jsx>{`
        .nav-links-mobile {
          display: none;
        }
        .nav-links-mobile.open {
          display: flex;
        }
        .nav-links-mobile li {
          text-align: left;
          padding-left: 20px;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
